import React, { useState, useRef } from "react";
import { Table, Input, Button, Space } from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import moment from "moment";

const Rendertable = ({ List }) => {
  console.log(List)
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInputRef = useRef(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInputRef}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : "",
    onFilterDropdownOpenChange: () => {
      setTimeout(() => {
        if (searchInputRef.current) {
          searchInputRef.current.select();
        }
      }, 100);
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "Off Day",
      dataIndex: "day_of_week",
      key: "day_of_week",
      ...getColumnSearchProps("day_of_week"),
    },
    {
      title: "Start Time",
      dataIndex: "start_time",
      key: "start_time",
      render: (value) => {
        if (!value) return "N/A"; 
        const time = moment(value, "HH:mm:ss"); 
        return time.isValid() ? time.format("HH:mm") : "Invalid Time";
      },
    },
    {
      title: "End Time",
      dataIndex: "end_time",
      key: "end_time",
      render: (value) => {
        if (!value) return "N/A"; 
        const time = moment(value, "HH:mm:ss");
        return time.isValid() ? time.format("HH:mm") : "Invalid Time";
      },
    },
  ];

  return (
    <div>
      <Table
        dataSource={Array.isArray(List) ? List : []} 
        columns={columns}
        rowKey={(record, index) => record.id || record.key || index} 
        pagination={{ pageSize: 5 }}
        bordered
      />
    </div>
  );
};

export default Rendertable;
